<template>
  <div class="pp-app-container">
    <header>
      <a href="https://castlabs.com" class="cl-logo-image" target="_blank">
        <img src="../assets/logo-white.png" alt="Logo">
      </a>
      <a class="button learn-more" href="https://castlabs.com/prestoplay/" target="_blank">Learn more</a>
      <div class="title">
        PRESTOplay for Web Apps
      </div>
    </header>

    <div class="pp-toolbar primary-links">
      <ul>
        <router-link-li :to="{name: 'player'}">Player</router-link-li>
        <router-link-li :to="{name: 'docs'}">Docs</router-link-li>
        <li><a href="https://castlabs.com/contact/" target="_blank">Contact us</a></li>
      </ul>
      <div class="search">
        <input type="search"
               placeholder="Search.."
               v-model="searchQuery"
               v-on:keyup.13="search">
      </div>
    </div>

    <div class='pp-content'>
      <router-view v-if='showRoutes'></router-view>
    </div>

    <footer>
      <ul>
        <li>{{versionLine}}</li>
        <li>Mode: {{devBuild ? 'Dev-Build' : 'Production-Build'}}</li>
        <li v-if="isLoggedIn">User: {{ name }}</li>
        <li v-if="isLoggedIn" @click="logout"><a href="javascript:void(0);">Logout</a></li>
        <li v-else><router-link :to="{name: 'login'}">Login</router-link></li>
        <li><a href="https://castlabs.com/privacy-cookie-policy/">Privacy & Cookie Policy</a></li>
        <li><a href="https://castlabs.com/legal/">Legal</a></li>
        <li>&copy;2020-{{year}} Castlabs</li>
      </ul>
    </footer>

  </div>
</template>

<script>
import * as storage from '../utils/storage';
import { ENV, getAppVersion } from '../utils/env';
import RouterLinkLi from './router/RouterLink.vue';

function isDefaultActive () {
  const p = storage.load('clpp-nav-bar');
  if (p !== null) {
    return p;
  }
  if (window.matchMedia) {
    return !window.matchMedia('(max-width: 600px)').matches;
  }
  return false;
}

export default {
  name: 'app',
  data () {
    return {
      menuVisible: isDefaultActive(),
      versionLine: getAppVersion(),
      devBuild: ENV.IS_DEVELOPMENT,
      searchQuery: null,
      year: new Date().getFullYear()
    };
  },
  watch: {
    license (license) {
      window.license = license;
    }
  },
  created () {
    window.license = this.license;
  },
  computed: {
    license () {
      return this.$store.state.player_settings.license;
    },
    isLoggedIn () {
      return this.$store.getters['assetdb/isLoggedIn'];
    },
    name () {
      return this.$store.state.assetdb.name;
    },
    showRoutes () {
      return (
        this.$store.state.scripts.loaded || this.$route.name === 'settings'
      );
    }
  },
  components: {
    RouterLinkLi,
  },
  methods: {
    toggleMenu () {
      this.menuVisible = !this.menuVisible;
      storage.persist('clpp-nav-bar', this.menuVisible);
    },
    hideMenu () {
      this.menuVisible = false;
      storage.persist('clpp-nav-bar', this.menuVisible);
    },
    search () {
      this.$router.push({
        name: 'search',
        query: { q: this.searchQuery }
      });
    },
    logout () {
      this.$store.dispatch('assetdb/logout');
    },
  }
};
</script>

<style lang="scss">

  @import "../style/color_";
  @import "../style/base_";
  @import "../style/typography_";
  @import "../style/table_";
  @import "../style/form_";
  @import "../style/button_";
  @import "../style/layout_";
  @import "../style/config_";
  @import "../style/docs_";

  $size-container-width: 1024px;
  $size-container-width-widescreen: 1400px;

  html, body, .viewport {
    padding: 0;
    margin: 0;
    width: 100%;
    height: 100%;
    min-width: 320px;
    scrollbar-width: thin;
  }

  body {
    font-family: Roboto,Noto Sans,-apple-system,BlinkMacSystemFont,sans-serif;
    font-size: 14px;
    color: $color-dark-gray;
    background-color: $color-background-page;
  }

  ul, li {
    padding: 0;
    margin: 0;
  }

  .pp-app-container {
    display: flex;
    flex-direction: column;
    min-height: 100%;

    max-width: $size-container-width;
    margin: auto;
    background-color: $color-background-content;
  }

  @media only screen and (min-width: 1600px) {
    .pp-app-container {
      max-width: $size-container-width-widescreen;
    }
  }

  .clearfix {
    overflow: auto;
  }

  .clearfix::after {
    content: "";
    clear: both;
    display: table;
  }

  ::-webkit-scrollbar {
    width: 6px;
    height: 4px;
  }

  ::-webkit-scrollbar-track {
    background-color: $color-background-content;
  }

  ::-webkit-scrollbar-thumb {
    background-color: $color-quaternary;
  }

  header {
    background-color: $color-cl-red;

    position: relative;

    .cl-logo-image {
      position: absolute;
      top: 0;
      left: 0;

      img {
        position: relative;
        top: 12px;
        left: 14px;
        height: 35px;
      }
    }
    .title {
      color: white;
      font-size: 20px;

      text-align: center;
      margin-top: 68px;
    }

    .learn-more {
      border: 1px solid white;
      background-color: transparent;
      color: white;
      font-size: 14px;
      border-radius: 5px;
      text-transform: none;
      cursor: pointer;

      position: absolute;
      top: 0;
      right: 0;
      margin: 16px;
    }
  }

  footer {
    padding: 8px;
    ul {
      width: 100%;
      color: $color-light-gray;
      font-size: 12px;
      text-align : center;
      li {
        display: inline;
        margin-left: 4px;
      }
      li:after {
        content: " \2022 ";
      }
      li:last-child:after {
        content: "";
      }
    }
  }

  .pp-toolbar {
    overflow: auto;
    white-space: nowrap;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin: 0
    }

    ul {
      overflow: auto;
      flex: 1 1 auto;

      color: $color-light-gray;
      background-color: $color-toolbar-bg;
      font-size: 12px;

      li {
        cursor: pointer;
        display: inline-block;
        text-align : center;
        font-size: 16px; // TODO: make bigger on ms 18
        margin: 0 12px; // 16
        padding: 12px 8px; // 16

        &.disabled {
          color: $color-secondary;
          cursor: default;
        }

        a {
          color: $color-light-gray;
        }
      }
    }
  }
  .pp-toolbar-transparent {
    ul {
      background-color: transparent;
      flex-grow: 0;
    }
  }

  .primary-links, .pp-sub-nav {
    .router-link-active {
      color: $color-cl-red;
      border-bottom: 2px solid $color-cl-red;
    }
  }

  .pp-content {
    flex: 1 0;
    /*padding: 8px;*/
  }

  @media (min-width: 600px){
    header {
      height: 68px;

      .title {
        margin: auto auto auto 200px;
        padding-top: 18px;
        text-align: left;
        font-size: 20px;
        height: 100%;
      }
    }
    footer {
      padding-top: 16px;
      padding-bottom: 16px;
    }

    .pp-toolbar {
      ul {
        li {
          font-size: 18px;
          margin: 0 16px;
          padding: 16px;
        }
      }
    }
  }

  .scroll-on-focus {
    overflow: hidden;
  }

  .search {
    width: 200px;
  }

  .primary-links {
    background-color: whitesmoke;
  }
</style>
